import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PATCH RUNTIME : évite le 308 apex->www qui casse cookies + CORS en prod.
(() => {
  const TARGETS = ['https://teamgazelle.net', 'https://www.teamgazelle.net'];
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (!origin || !/teamgazelle\.net$/i.test(window.location.hostname)) return;
  const origFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    try {
      if (typeof input === 'string') {
        for (const t of TARGETS) {
          if (input.startsWith(t + '/')) {
            input = origin + input.slice(t.length);
            break;
          }
        }
      } else if (input && input.url) {
        for (const t of TARGETS) {
          if (input.url.startsWith(t + '/')) {
            input = new Request(origin + input.url.slice(t.length), input);
            break;
          }
        }
      }
    } catch (e) {}
    return origFetch(input, init);
  };
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Enregistre le Service Worker (push notifications + purge cache).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update().catch(() => {});
    }).catch(() => {});
  });
}

// Filet de sécurité : si un chunk JS est introuvable après un déploiement,
// on purge les caches et on recharge une seule fois.
window.addEventListener('error', (e) => {
  const msg = (e && e.message) || '';
  const isChunkError = msg.includes('Unexpected token') || msg.includes('ChunkLoadError') || msg.includes('Loading chunk');
  if (isChunkError && !sessionStorage.getItem('gz_recovered')) {
    sessionStorage.setItem('gz_recovered', '1');
    const reload = () => window.location.reload();
    if ('caches' in window) {
      caches.keys().then((ks) => Promise.all(ks.map((k) => caches.delete(k)))).then(reload, reload);
    } else {
      reload();
    }
  }
});
